import { render } from "./recentAssignments.vue?vue&type=template&id=75d7d5d2"
import script from "./recentAssignments.vue?vue&type=script&lang=js"
export * from "./recentAssignments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__